"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCheckedItem = exports.updateDynamicList = exports.updateStaticList = void 0;
var state_1 = __importDefault(require("../state/state"));
var menuState_1 = require("../state/menuState");
var updateDynamicList = function (target) {
    var categoryName = target.id.replace(/[0-9]+/, '');
    var category = menuState_1.menuState[categoryName];
    var masterItem = category.filter(function (item) { return item.id === target.id; })[0];
    state_1.default.selectedItem = target.checked
        ? __spreadArray(__spreadArray([], state_1.default.selectedItem, true), [masterItem], false) : state_1.default.selectedItem.filter(function (item) { return item.id !== masterItem.id; });
    state_1.default.selectedItem = state_1.default.selectedItem.map(function (item) {
        return item.hasOwnProperty('quantity') ? item : __assign(__assign({}, item), { quantity: 1 });
    });
};
exports.updateDynamicList = updateDynamicList;
var updateStaticList = function (target) {
    var categoryName = target.id.replace(/[0-9]+/, '');
    var category = menuState_1.menuState[categoryName];
    var masterItem = category.filter(function (item) { return item.id === target.id; })[0];
    state_1.default.selectedItem = __spreadArray(__spreadArray([], state_1.default.selectedItem.filter(function (item) { return item.id.replace(/[0-9]+/, '') !== categoryName; }), true), category.filter(function (item) { return item.id === masterItem.id; }), true);
    state_1.default.selectedItem = state_1.default.selectedItem.map(function (item) {
        return item.hasOwnProperty('quantity') ? item : __assign(__assign({}, item), { quantity: 1 });
    });
};
exports.updateStaticList = updateStaticList;
var deleteCheckedItem = function (target) {
    var deleteItemId = target.id.replace('selected-', '');
    state_1.default.selectedItem = state_1.default.selectedItem.filter(function (item) { return item.id !== deleteItemId; });
};
exports.deleteCheckedItem = deleteCheckedItem;
